export default function FullTaxGrid() {

    return (
        <div> Icecat Taxonomy Reports Page coming soon...</div>
    )
}